<!-- eslint-disable -->
<template>
  <v-container class="login-container">
    <v-row justify="center" align="center" style="min-height: 80vh;">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card elevation="8" class="pa-8">
          <v-card-title class="text-h4 text-center mb-6">
            <v-icon size="large" color="primary" class="mr-2">mdi-account-group</v-icon>
            <div>{{ $t('home.title') }}</div>
          </v-card-title>

          <v-card-subtitle class="text-center mb-6">
            {{ $t('auth.loginSubtitle') }}
          </v-card-subtitle>

          <v-alert v-if="errorMessage" type="error" class="mb-4">
            {{ errorMessage }}
          </v-alert>

          <v-form @submit.prevent="handleLogin" ref="formRef">
            <v-text-field
              v-model="email"
              :label="$t('auth.email')"
              type="email"
              prepend-inner-icon="mdi-email"
              variant="outlined"
              :rules="[rules.required, rules.email]"
              class="mb-4"
            ></v-text-field>

            <v-text-field
              v-model="password"
              :label="$t('auth.password')"
              :type="showPassword ? 'text' : 'password'"
              prepend-inner-icon="mdi-lock"
              :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append-inner="showPassword = !showPassword"
              variant="outlined"
              :rules="[rules.required]"
              class="mb-2"
            ></v-text-field>

            <div class="text-right mb-4">
              <router-link to="/forgot-password" class="text-caption text-grey">
                {{ $t('auth.forgotPassword') }}
              </router-link>
            </div>

            <v-btn
              type="submit"
              color="primary"
              size="large"
              block
              :loading="loading"
              class="mb-4"
            >
              {{ $t('nav.login') }}
            </v-btn>

            <v-divider class="my-6"></v-divider>

            <div class="text-center">
              <p class="text-body-2 mb-2">
                {{ $t('auth.noAccount') }}
              </p>
              <v-btn
                color="primary"
                variant="outlined"
                @click="$router.push('/register')"
              >
                {{ $t('auth.createAccount') }}
              </v-btn>
            </div>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

const store = useStore()
const router = useRouter()
const { t } = useI18n()

const formRef = ref(null)
const email = ref('')
const password = ref('')
const showPassword = ref(false)
const loading = ref(false)
const errorMessage = ref('')

const rules = {
  required: v => !!v || t('validation.required') || 'Required',
  email: v => /.+@.+\..+/.test(v) || t('validation.email') || 'Invalid email'
}

const handleLogin = async () => {
  const { valid } = await formRef.value.validate()
  if (!valid) return

  loading.value = true
  errorMessage.value = ''

  try {
    const result = await store.dispatch('auth/login', {
      email: email.value,
      password: password.value
    })

    if (result.success) {
      router.push(result.redirectTo || '/wall')
    } else {
      errorMessage.value = result.error || t('auth.loginFailed') || 'Login failed'
    }
  } catch (error) {
    errorMessage.value = t('auth.loginFailed') || 'An error occurred during login'
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.login-container {
  background: linear-gradient(135deg, #f5f5f5 0%, #e8f5e9 100%);
  min-height: 100vh;
}
</style>